exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PerDayStats > * {\n  margin: auto;\n}\n.PerDayStats table {\n  table-layout: fixed;\n}\n.PerDayStats td,\n.PerDayStats th {\n  text-align: center;\n  width: 35px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/admin/components/tables/PerDayStats.less
// module id = 1342
// module chunks = 0